/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Tab_BidInputs */

const en_directory_submit_tab_bid = /** @type {(inputs: Directory_Submit_Tab_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bid for placement`)
};

const zh_directory_submit_tab_bid = /** @type {(inputs: Directory_Submit_Tab_BidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`出价占位`)
};

/**
* | output |
* | --- |
* | "Bid for placement" |
*
* @param {Directory_Submit_Tab_BidInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_tab_bid = /** @type {((inputs?: Directory_Submit_Tab_BidInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Tab_BidInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_tab_bid(inputs)
	return zh_directory_submit_tab_bid(inputs)
});
export { directory_submit_tab_bid as "directory.submit.tab.bid" }